import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'error-circle';

const originalDimensions = {
    width: 24,
    height: 24,
};

export const IconErrorCircle = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;
    const classNames = cx('inline', addClasses);

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Error Circle Icon</title>
            <path
                d="M10 0a10 10 0 1010 10A10 10 0 0010 0zm4.28 12.86a1 1 0 11-1.42 1.42L10 11.45l-2.79 2.83a1 1 0 11-1.42-1.42L8.62 10 5.79 7.21a1 1 0 011.42-1.42L10 8.62l2.82-2.83a1 1 0 111.42 1.42L11.45 10z"
                fill={fill}
            />
        </svg>
    );
};
